module.exports = __webpack_public_path__ + "static/media/user.e485a141.svg";